class Prefix {
  constructor(data, numberOfDays) {
    this.numberOfDays = numberOfDays;

    this.data = Object.keys(data).map(prefix => {
      const sourceIP = [];
      let prefixHitsCount = 0;

      Object.keys(data[prefix].ip).map(ip => {
        Object.keys(data[prefix].ip[ip].protocol).map(protocol => {
          Object.keys(
            data[prefix].ip[ip].protocol[protocol].destinationPort
          ).map(port => {
            const count =
              data[prefix].ip[ip].protocol[protocol].destinationPort[port].hits;
            prefixHitsCount += count;
            sourceIP.push({
              ip,
              protocol,
              port,
              count
            });
          });
        });
      });

      return {
        prefix,
        count: prefixHitsCount,
        sourceIP
      };
    });
  }
}

// format PrefixData according to prefix and protocol, i.e. different combination of prefix and protocol, leads to different elements in the formatted PrefixData array
const formatPrefixData = data => {
  // Deep copy data before formatting
  const prefixData = JSON.parse(JSON.stringify(data));

  // sort by protocol, it's a critical step for formatting the data
  // if protocol is the same sort by ip,
  // if protocol and ip are the same sort by port
  prefixData.forEach(prefixObj => {
    prefixObj.sourceIP.sort((a, b) => {
      if (a.protocol < b.protocol) {
        return 1;
      } else if (a.protocol > b.protocol) {
        return -1;
      } else {
        if (a.ip > b.ip) {
          return 1;
        } else if (a.ip < b.ip) {
          return -1;
        } else {
          if (a.port < b.port) {
            return 1;
          } else {
            return -1;
          }
        }
      }
    });
  });

  const formattedPrefixData = [];

  prefixData.forEach(prefixObj => {
    let newPrefix = {
      prefix: prefixObj.prefix,
      count: 0,
      sourceIP: [],
      protocol: ''
    };

    prefixObj.sourceIP.forEach((sourceIPObj, index) => {
      if (newPrefix.sourceIP.length === 0) {
        newPrefix.sourceIP.push(sourceIPObj);
        newPrefix.protocol = sourceIPObj.protocol;
        newPrefix.count += sourceIPObj.count;
      } else {
        // when property of protocol is changed, store the data as a new element in formattedPrefixData
        if (
          newPrefix.sourceIP.every(i => i.protocol === sourceIPObj.protocol)
        ) {
          newPrefix.sourceIP.push(sourceIPObj);
          newPrefix.count += sourceIPObj.count;
        } else {
          formattedPrefixData.push(newPrefix);
          newPrefix = {
            prefix: prefixObj.prefix,
            count: 0,
            sourceIP: [],
            protocol: ''
          };
          newPrefix.sourceIP.push(sourceIPObj);
          newPrefix.protocol = sourceIPObj.protocol;
          newPrefix.count += sourceIPObj.count;
        }
      }
    });
    formattedPrefixData.push(newPrefix);
  });

  // sort formattedPrefixData by property of count (hits), 1st element will have the hightest count
  formattedPrefixData.sort((a, b) => (a.count < b.count ? 1 : -1));

  return formattedPrefixData;
};

export default Prefix;
export { formatPrefixData };
